import { typographyVariants } from '@mint-lib/tw-components';
import type { TooltipContentProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

import ChartTooltip from '../ChartTooltip/ChartTooltip.jsx';

type TooltipProps = TooltipContentProps<ValueType, NameType>;

const PieTooltip = ({ active, payload }: TooltipProps) => {
  if (!active || !payload?.length) {
    return null;
  }

  const {
    payload: { value: tooltipData, fill },
    value,
  } = payload[0];

  return (
    <ChartTooltip className="flex-row">
      <div
        style={{ backgroundColor: fill }}
        className="h-7.5 w-1 items-center"
      />
      <div className="flex flex-col">
        <p
          className={typographyVariants({
            variant: 'bodyShort01',
            color: 'primary',
          })}
        >
          {tooltipData}
        </p>
        <p
          className={typographyVariants({
            variant: 'label01',
            color: 'primary',
          })}
        >
          {Number(value).toFixed(2)}
        </p>
      </div>
    </ChartTooltip>
  );
};

export default PieTooltip;
